import React from 'react'
import ViewStockEntry from './Partials/ViewStockEntry'

const ViewStocks = () => {
    return (
        <ViewStockEntry />
    )
}

export default ViewStocks